import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { IonicPage } from 'ionic-angular';
import * as moment from 'moment';
import { Moment } from 'moment';
import 'moment/locale/nl';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/take';
import { WeekSelectorComponent } from '../../components/week-selector/week-selector';
import { Auth0Provider } from "../../providers/auth0.provider";
import { API_ENDPOINT } from '../../providers/generic.service';
import { TimesheetService } from '../timesheets/providers/timesheet.service';


@IonicPage()
@Component({
  selector: 'page-report',
  templateUrl: 'reports.html',
  encapsulation: ViewEncapsulation.None
})
export class ReportsPage implements OnInit {

  @ViewChild( 'weekSelector' ) weekSelector: WeekSelectorComponent;

  /**
   * The moment to select
   * @param {Moment} selection
   */
  selectWeek( isoWeek: Moment ): void {
    const currentWeekNumber = isoWeek.isoWeek();
    const currentYear = isoWeek.isoWeekYear();
    this.weekSelector.setWeek( currentWeekNumber, currentYear );
  }

  exportTimesheet() {

    /** The current JWT token */
    const token = this.$auth0Provider.token('id');

    /** Preferably I would have used URLSearchParams, but for best support I will do it this way */
    const queryParams = `access_token=${token}`;

    console.log( `[EXPORT-TIMESHEET] Downloading timeseheet ${API_ENDPOINT} /timesheets/${this.weekSelector.currentYear}/${this.weekSelector.currentWeekNumber}` );
    window.open( API_ENDPOINT + `/admin/timesheets/export/${this.weekSelector.currentYear}/${this.weekSelector.currentWeekNumber}?${queryParams}` );
  }

  ngOnInit() {
    const localStorageData = this.$timeService.getStoredTimesheetData();
    const now = moment();

    // Determine selected week and year
    //
    if ( localStorageData.isoWeek && localStorageData.year )
    {
      now.set( 'year', localStorageData.year );
      now.set( 'isoWeek', localStorageData.isoWeek );
    }

    this.selectWeek( now );
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad TimesheetsPage');
  }

  log(e) {
    console.log(e);
  }

  constructor(
    private $auth0Provider: Auth0Provider,
    private $timeService: TimesheetService ) { }
}



// WEBPACK FOOTER //
// ./src/pages/reports/reports.ts